<template>
    <div style="display: flex">
        <div class="TopBtn" :class="{ 'bottom-bar': btnPosition === 'bottom' }">
            <div v-for="btn in topBtns" :key="btn" class="commandBtn" :code="btn.btnCode">
                <el-button plain @click.native="handleBtnClick(btn)">
                    <svg-icon v-if="btn.btnIcon.indexOf('.svg') !== -1" :icon-class="btn.btnIcon.substring(0, btn.btnIcon.indexOf('.svg'))" :class="btn.btnIcon.substring(0, btn.btnIcon.indexOf('.svg'))" />
                    <i v-if="btn.btnIcon.indexOf('.svg') === -1" :class="'el-icon-' + btn.btnIcon" />
                    <span>{{ btn.btnName }}</span>
                </el-button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TopBtn',
    components: {},
    props: {
        topBtn: {
            type: Array,
            default: function () {
                return []
            }
        },
        btnPosition: {
            type: String,
            default: function () {
                return 'top'
            }
        }
    },
    data() {
        return {
            topBtns: [],
            submitBtn: null
        }
    },
    computed: {},
    watch: {
        TopBtn: {
            handler: function (newValue, oldValue) {
                this.setCommandBtns()
            },
            deep: true
        }
    },
    created() {
        this.setCommandBtns()
    },
    beforeDestroy() {},
    mounted() {},
    methods: {
        setCommandBtns() {
            this.topBtns = []
            this.topBtns = this.topBtn
        },
        handleBtnClick(btn) {
            console.log(btn, 'btn')
            if (btn.btnParams !== undefined && btn.btnParams !== null) {
                btn.btnClick.apply(this.$vnode.context, btn.btnParams)
            } else {
                btn.btnClick.apply(this.$vnode.context)
            }
        }
    }
}
</script>

<style scoped lang="scss">
@import '~@/wapp/common/styles/variables.module.scss';

.TopBtn-dropdown-menu {
    margin-top: 0px !important;
    text-align: center;
}

.TopBtn {
    background: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    .commandBtn {
        margin-right: 14px;
    }

    .glyphicon-off {
        color: #ff0000;
    }
    .download {
        color: #0e830e;
    }
    .save {
        color: darkblue;
    }
    .el-icon-setting {
        color: #ff7b00d8;
    }
    .el-icon-edit {
        color: darkblue;
    }
    .el-icon-edit-outline {
        color: darkblue;
    }
    .el-icon-refresh-left {
        color: #ff7b00d8;
    }
}
.bottom-bar {
    z-index: 1000 !important;
    margin: 0 auto;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 76px;
    box-shadow: 0px -2px 4px 0px rgba(0, 0, 0, 0.06);
}
</style>
